.inputPhoneContainer {
  width: 100%;
}

.phoneInputWrapper {
  display: flex;
  align-items: flex-start;
  position: relative;
}

.phoneInputCombined {
  display: flex;
  width: 100%;
  min-height: 36px;
  border: 1px solid var(--vkui--color_field_border_alpha);
  border-radius: 8px;
  overflow: hidden;
  align-items: center;
  position: relative;
  background: var(--vkui--color_background_secondary);
}

.phoneInputCombinedError {
  border-color: var(--vkui--color_stroke_negative);
  background-color: var(--vkui--color_background_negative_tint);
}

.countryCodeDisplay {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0 12px;
  height: 100%;
  width: auto;
  min-width: auto;
  border-right: 1px solid var(--vkui--color_field_border_alpha);
  background: var(--vkui--color_background_secondary);
  color: var(--vkui--color_text_primary);
  font-size: 16px;
  cursor: pointer;
  user-select: none;
  position: relative;
  white-space: nowrap;
  outline: none;
  flex-shrink: 0;
}

.phoneInputCombinedError .countryCodeDisplay {
  border-right-color: var(--vkui--color_stroke_negative);
  background: transparent;
}

.chevronDown {
  transition: transform 0.2s ease;
}

.chevronUp {
  transition: transform 0.2s ease;
  transform: rotate(180deg);
}

.phoneInput {
  flex: 1;
  border: 0;
  border-radius: 0;
  background: transparent;
  padding: 0 12px;
  font-size: 16px;
  font-family: inherit;
  color: var(--vkui--color_text_primary);
  outline: none;
  height: 100%;
  min-height: 36px;
}

.errorMessage {
  color: var(--vkui--color_text_negative);
  font-size: 14px;
  margin-top: 8px;
  padding-left: 12px;
}

.countrySelectDropdown {
  position: absolute;
  top: calc(100% + 10px);
  width: calc(100% - 2px);
  max-width: 356px;
  max-height: 36vh;
  overflow-y: auto;
  background: var(--vkui--color_background_content);
  border: 1px solid var(--vkui--color_separator_primary);
  border-radius: 12px;
  z-index: 100;
  animation: fade-in 0.2s ease-out;
}

.countrySelectPanel {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  max-height: 70vh;
  background: var(--vkui--color_background_content);
  border-radius: 16px 16px 0 0;
  z-index: 100;
  overflow-y: auto;
  animation: slideUp 0.3s ease-out;
  padding-top: 8px;
  transition: transform 0.2s ease-out;
}

.countrySelectPanelDragging {
  transition: none;
}

.countrySelectHandle {
  width: 36px;
  height: 4px;
  background: var(--vkui--color_field_border_alpha);
  border-radius: 2px;
  margin: 0 auto 16px;
}

.countrySelectHeader {
  padding: 0 20px 16px;
  font-size: 20px;
  font-weight: 600;
  color: var(--vkui--color_text_primary);
  text-align: center;
}

.mobileCountryOption {
  min-height: 56px;
  height: 56px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  color: var(--vkui--color_text_primary);
  font-size: 16px;
}

.mobileCountryOption:active {
  background: var(--vkui--color_background_secondary);
}

.dialCode {
  color: var(--vkui--color_text_secondary);
  display: inline;
}

.countryOption {
  padding: 8px 12px;
  cursor: pointer;
  font-size: 16px;
  color: var(--vkui--color_text_primary);
  transition: background-color 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 20px;
}

.countryOption:hover,
.countryOption:active {
  background: var(--vkui--color_background_secondary);
}

.countryOptionSelected {
  background: var(--vkui--color_background_secondary);
}

.backdrop {
  position: fixed;
  inset: 0;
  background: var(--vkui--color_overlay_primary, rgb(0 0 0 / 40%));
  z-index: 99;
  animation: fade-in-backdrop 0.3s ease-out;
}

@media (width >= 769px) {
  .backdrop {
    display: none;
  }
}

@keyframes fade-in {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slide-up {
  from {
    transform: translateY(100%);
  }

  to {
    transform: translateY(0);
  }
}

@keyframes fade-in-backdrop {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@media (width <= 768px) {
  .countrySelectDropdown {
    display: none;
  }
}

@media (width >= 769px) {
  .countrySelectPanel {
    display: none;
  }
}
